import locatorMapStyle from '../../json/LocatorCustomStyleMap';
import ApiManager from '../api/crud-manager';
import {
  activateGoogleSearchApi,
  buildCategoryFiltering,
  buildSpotsList,
  calculateDistanceLngLat,
  setLocationContainerData,
  setRouteDirection,
  smoothZoomMap
} from '../utils/locator';

const locator = {
  showInfoPanel: false,
  showSpotsList: true,
  showInfoWindow: true,
  activeDirectionsService: true
};

const polylineOptions = {
  strokeColor: '#004783',
  strokeOpacity: 0,
  fillOpacity: 0,
  icons: [
    {
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        fillOpacity: 1,
        scale: 3
      },
      offset: '0',
      repeat: '10px'
    }
  ]
};

const allMarkers = [];
let directionsService;
let directionsRenderer;
let destinationLat;
let destinationLng;
let map;
let stores;
let startMarker;

class LocatorA {
  constructor(options = {}) {
    this.config = {
      locatorMaps: () => document.querySelectorAll('[data-module="Locator__MapA"]'),
      filterButtons: () =>
        document.querySelectorAll('[data-child-module="Locator__ToggleFilters"]'),
      markerIconHome: '/dist/images/icons/maps-marker-home.svg',
      markerIconLocation: '/dist/images/icons/maps-marker-location.svg',
      markerIconActive: '/dist/images/icons/maps-marker-active.svg',
      setHomeIcon: true,
      siteName: 'Projectname',
      infoWindow: new google.maps.InfoWindow({ content: '', ariaLabel: '' }),
      ...options
    };

    this.apiManager = new ApiManager();
  }

  init() {
    const { locatorMaps, markerIconHome, setHomeIcon, siteName } = this.config;

    this.addEventListeners();

    locatorMaps().forEach(moduleMap => {
      const mapCenterLocation =
        moduleMap.getAttribute('data-map-center') !== ''
          ? moduleMap.getAttribute('data-map-center')
          : '51.477928, -0.001545';
      const mapCenterLatitude = Number(mapCenterLocation.split(',')[0]);
      const mapCenterLongitude = Number(mapCenterLocation.split(',')[1]);
      const headquarterLocation =
        moduleMap.getAttribute('data-headquarter') !== ''
          ? moduleMap.getAttribute('data-headquarter')
          : '0.0 0.0';
      destinationLat = Number(headquarterLocation.split(',')[0]);
      destinationLng = Number(headquarterLocation.split(',')[1]);

      locator.showInfoPanel = moduleMap.getAttribute('data-showInfoPanel') === 'true';
      if (locator.showInfoPanel) {
        locator.showInfoWindow = false;
      }

      const mapOptions = {
        center: { lat: mapCenterLatitude, lng: mapCenterLongitude },
        zoom:
          moduleMap.getAttribute('data-zoom-level') !== ''
            ? Number(moduleMap.getAttribute('data-zoom-level'))
            : 8,
        maxZoom: 18,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        fullscreenControl: false,
        styles: locatorMapStyle
      };

      if (typeof google === 'object' && typeof google.maps === 'object') {
        map = new google.maps.Map(moduleMap, mapOptions);

        directionsRenderer = new google.maps.DirectionsRenderer({
          polylineOptions,
          suppressMarkers: true,
          map
        });

        this.setLocationsData();

        if (setHomeIcon && locator.activeDirectionsService) {
          const startLatLng = new google.maps.LatLng(destinationLat, destinationLng);
          startMarker = new google.maps.Marker({
            position: startLatLng,
            map,
            title: siteName,
            zIndex: 9,
            icon: markerIconHome
          });
          startMarker.setPosition(startLatLng);

          if (locator.activeDirectionsService) {
            directionsService = new google.maps.DirectionsService();
          }
        } else {
          const travelmodes = document.querySelectorAll('[data-module="LocatorGmapsTravel"]');
          travelmodes.forEach(travelmode => {
            const travelmodeEl = travelmode;
            travelmodeEl.style.display = 'none';
          });
        }

        google.maps.event.addListener(map, 'click', () => {
          if (locator.showInfoWindow) {
            this.config.infoWindow.close();
          }
        });
      }
    });
  }

  addEventListeners() {
    const buttons = this.config.filterButtons();

    const toggleSpotsCategories = () => {
      const categoriesContainers = document.querySelectorAll(
        '[data-child-module="Locator__ToggleView"]'
      );
      categoriesContainers.forEach(categoriesContainer => {
        const container = categoriesContainer;
        if (container.style.display === 'none') {
          container.removeAttribute('style');
        } else {
          container.style.display = 'none';
        }
      });
    };

    if (buttons) {
      buttons.forEach(el => {
        el.addEventListener('click', toggleSpotsCategories);
      });
    }
  }

  addMarkers(data) {
    const { markerIconLocation, markerIconActive } = this.config;

    if (!data) {
      return;
    }

    data.features.forEach(feature => {
      // Maak een nieuwe array met geldige properties
      const validProperties = feature.properties.filter(
        item => item.Latitude != null && item.Longitude != null
      );

      validProperties.forEach(item => {
        const lng = Number(item.Longitude.replace(',', '.')) || null;
        const lat = Number(item.Latitude.replace(',', '.')) || null;
        const markerExists = allMarkers.some(m => m.id === item.Id);
        const categoriesTrimmed = item.Categories.map(c => c.trim());

        if (!markerExists) {
          const marker = new google.maps.Marker({
            position: { lat, lng },
            map,
            title: item.CompanyName,
            id: item.Id,
            icon: markerIconLocation,
            category: categoriesTrimmed,
            lat,
            lng
          });

          marker.addListener('click', () => {
            if (locator.showInfoPanel) {
              setLocationContainerData(item, locator.showInfoPanel, locator.showInfoWindow, marker);
            }

            if (locator.showInfoWindow) {
              this.openInfoWindow(marker, item);
            }

            for (let j = 0; j < allMarkers.length; j += 1) {
              allMarkers[j].setIcon(markerIconLocation);
            }
            marker.setIcon(markerIconActive);

            const clickedMarkerLocation = { lat, lng };
            map.panTo(clickedMarkerLocation);

            if (locator.activeDirectionsService) {
              directionsRenderer.setDirections({ routes: [] });

              const contentDistances = blockNone =>
                document.querySelectorAll('[data-module="TotalTimeDistance"]').forEach(totals => {
                  const totalsEl = totals;
                  totalsEl.style.display = blockNone;
                });

              const travelmodeItems = document.querySelectorAll(
                '[data-child-module="LocatorGmapsTravel__Item"]'
              );

              travelmodeItems.forEach(travelmodeItem => {
                const travelItem = travelmodeItem;
                travelItem.classList.remove('is-active');
                contentDistances('none');
                travelItem.dataset.lat = lat;
                travelItem.dataset.lng = lng;
                if (travelItem.dataset.initialized === 'true') {
                  return;
                }
                travelItem.dataset.initialized = 'true';

                travelItem.addEventListener('click', () => {
                  travelmodeItems.forEach(others => {
                    others.classList.remove('is-active');
                  });
                  contentDistances('block');
                  travelItem.classList.add('is-active');
                  setRouteDirection(
                    Number(travelItem.dataset.lat),
                    Number(travelItem.dataset.lng),
                    travelItem.value,
                    destinationLat,
                    destinationLng,
                    directionsService,
                    directionsRenderer
                  );
                });
              });
            }

            smoothZoomMap(map, map.getZoom(), 12);
          });

          allMarkers.push(marker);
        } else {
          const markerIndex = allMarkers.findIndex(m => m.id === item.Id);
          const mergedCategories = [
            ...categoriesTrimmed,
            ...allMarkers[markerIndex].category
          ].filter((cat, index, self) => self.indexOf(cat) === index);

          allMarkers[markerIndex].category = mergedCategories;
        }
      });
    });
  }

  openInfoWindow(markerData, data) {
    this.config.infoWindow.close();
    this.config.infoWindow.setContent(
      setLocationContainerData(data, locator.showInfoPanel, locator.showInfoWindow)
    );
    this.config.infoWindow.open({ map: markerData.getMap(), anchor: markerData });

    google.maps.event.addListener(this.config.infoWindow, 'closeclick', () => {
      const markerIconLocation = '/dist/images/icons/maps-marker-location.svg';
      markerData.setIcon(markerIconLocation);
    });
  }

  setLocationsData() {
    const { lang } = document.documentElement;

    this.apiManager
      .get('/api/v1/storelocater/getalllocations')
      .then(data => {
        let containsNumberSign = false;
        data.forEach(d => {
          containsNumberSign = String(d.Categories).includes('1#');
          const spotsByCulture = data.filter(
            x => x.Culture != null && x.Culture.toLowerCase() === lang.toLowerCase()
          );

          if (!containsNumberSign) {
            stores = spotsByCulture.reduce((newArr, originalItem) => {
              originalItem.Categories.forEach(c => {
                if (!String(c).includes('#')) {
                  const category = c.trim();
                  const catIndex = newArr.findIndex(x => x.categoryId === category);

                  if (catIndex === -1) {
                    newArr.push({ categoryId: category, category, properties: [originalItem] });
                  } else {
                    newArr[catIndex].properties.push(originalItem);
                  }
                }
              });
              return newArr;
            }, []);
          }
        });

        const locations = {
          type: 'FeatureCollection',
          features: stores
        };

        locations.features = locations.features.map(feature => {
          const newProperties = feature.properties
            .filter(
              originalProperty =>
                originalProperty.Latitude != null && originalProperty.Longitude != null
            )
            .map(originalProperty => {
              const itemLat = Number(originalProperty.Latitude.replace(',', '.'));
              const itemLon = Number(originalProperty.Longitude.replace(',', '.'));
              const destLat = Number(destinationLat);
              const destLng = Number(destinationLng);

              const distanceValue = calculateDistanceLngLat(itemLat, itemLon, destLat, destLng)
                .toFixed(1)
                .replace('.', ',');

              return { ...originalProperty, Distance: distanceValue };
            });

          return { ...feature, properties: newProperties };
        });

        this.addMarkers(locations);
        buildCategoryFiltering(locations, allMarkers, destinationLat, destinationLng, true);

        if (locator.showSpotsList) {
          buildSpotsList(locations, allMarkers);
          activateGoogleSearchApi(map, locations, allMarkers, LocatorA.setCenterLngLat, {
            destinationLat,
            destinationLng
          });
        }
      })
      .catch(err => {
        console.error(err);
      });
  }
}

export default LocatorA;
